// Bakery department seed data — products, categories, distribution points

const STORAGE_KEY_DIST = 'desres_bakery_distribution_points'

// --- Bakery Product Categories ---
export const BAKERY_CATEGORIES_SEED = [
  { name: 'bread', label: 'Bread', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'fixed_unit', unitPrice: 11 },
  { name: 'school buns', label: 'School Buns', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  { name: 'yellow buns', label: 'Yellow Buns', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  { name: 'white rolls', label: 'White Rolls', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  { name: 'cream buns', label: 'Cream Buns', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  { name: 'pastry', label: 'Pastry', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  { name: 'other', label: 'Other', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  { name: 'sandwiches', label: 'Sandwiches', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
]

// --- Bakery Products (individual line items for production/distribution/sales tracking) ---
export const BAKERY_PRODUCTS_SEED = [
  // Bread
  { code: 'BREAD', name: 'Bread', category: 'bread', unitPrice: 11, saleType: 'fixed_unit', department: 'bakery' },

  // School Buns
  { code: 'SBUNS_20', name: 'School Buns (20)', category: 'school buns', unitPrice: 30, saleType: 'discrete', department: 'bakery' },
  { code: 'MSB_2', name: 'MSB 2', category: 'school buns', unitPrice: 4, saleType: 'discrete', department: 'bakery' },
  { code: 'MSB_3', name: 'MSB 3', category: 'school buns', unitPrice: 6, saleType: 'discrete', department: 'bakery' },
  { code: 'MSB_4', name: 'MSB 4', category: 'school buns', unitPrice: 8, saleType: 'discrete', department: 'bakery' },
  { code: 'MSB_4_DIS', name: 'MSB 4 dis', category: 'school buns', unitPrice: 6, saleType: 'discrete', department: 'bakery' },
  { code: 'MSB_5', name: 'MSB 5', category: 'school buns', unitPrice: 10, saleType: 'discrete', department: 'bakery' },
  { code: 'MSB_6', name: 'MSB 6', category: 'school buns', unitPrice: 12, saleType: 'discrete', department: 'bakery' },
  { code: 'MSB_12', name: 'MSB 12', category: 'school buns', unitPrice: 23, saleType: 'discrete', department: 'bakery' },

  // Yellow Buns
  { code: 'YEL_BUNS', name: 'Yellow Buns (20)', category: 'yellow buns', unitPrice: 38, saleType: 'discrete', department: 'bakery' },
  { code: 'YSB_2', name: 'YSB 2', category: 'yellow buns', unitPrice: 5, saleType: 'discrete', department: 'bakery' },
  { code: 'YSB_3', name: 'YSB 3', category: 'yellow buns', unitPrice: 7, saleType: 'discrete', department: 'bakery' },
  { code: 'YSB_4', name: 'YSB 4', category: 'yellow buns', unitPrice: 9, saleType: 'discrete', department: 'bakery' },
  { code: 'YSB_4_DIS', name: 'YSB 4 dis', category: 'yellow buns', unitPrice: 6, saleType: 'discrete', department: 'bakery' },
  { code: 'YSB_5', name: 'YSB 5', category: 'yellow buns', unitPrice: 11, saleType: 'discrete', department: 'bakery' },
  { code: 'YSB_6', name: 'YSB 6', category: 'yellow buns', unitPrice: 13, saleType: 'discrete', department: 'bakery' },
  { code: 'YSB_6_DIS', name: 'YSB 6 dis', category: 'yellow buns', unitPrice: 6, saleType: 'discrete', department: 'bakery' },
  { code: 'YEL_ROLLS', name: 'Yellow Rolls', category: 'yellow buns', unitPrice: 12, saleType: 'discrete', department: 'bakery' },

  // White Rolls
  { code: 'WR_6', name: 'White Rolls (6)', category: 'white rolls', unitPrice: 15, saleType: 'discrete', department: 'bakery' },
  { code: 'WR_4', name: 'White Rolls (4)', category: 'white rolls', unitPrice: 10, saleType: 'discrete', department: 'bakery' },
  { code: 'WR_2_DIS', name: 'White Rolls (2) dis', category: 'white rolls', unitPrice: 6, saleType: 'discrete', department: 'bakery' },

  // Cream Buns
  { code: 'SCB_RAMA', name: 'SCB Rama', category: 'cream buns', unitPrice: 13, saleType: 'discrete', department: 'bakery' },
  { code: 'SCB_POL', name: 'SCB Polony', category: 'cream buns', unitPrice: 8, saleType: 'discrete', department: 'bakery' },
  { code: 'SB_POL_ATC', name: 'SB Polony & Atchaar', category: 'cream buns', unitPrice: 7, saleType: 'discrete', department: 'bakery' },

  // Pastry
  { code: 'SCONES', name: 'Scones', category: 'pastry', unitPrice: 2, saleType: 'fixed_unit', department: 'bakery' },
  { code: 'SC4', name: 'Scones(4)', category: 'pastry', unitPrice: 9, saleType: 'discrete', department: 'bakery' },
  { code: 'FATCOOK', name: 'Fatcook', category: 'pastry', unitPrice: 2, saleType: 'fixed_unit', department: 'bakery' },
  { code: 'GINGER', name: 'Ginger', category: 'pastry', unitPrice: 3, saleType: 'fixed_unit', department: 'bakery' },
  { code: 'MUFFIN', name: 'Muffin', category: 'pastry', unitPrice: 12, saleType: 'fixed_unit', department: 'bakery' },

  // Other
  { code: 'HOTDOG_BUNS', name: 'Hotdog Buns', category: 'other', unitPrice: 17, saleType: 'fixed_unit', department: 'bakery' },
  { code: 'POLONY_BUNS', name: 'Polony Buns', category: 'other', unitPrice: 14, saleType: 'fixed_unit', department: 'bakery' },
  { code: 'RUSSIAN', name: 'Russian', category: 'other', unitPrice: 8, saleType: 'fixed_unit', department: 'bakery' },
  { code: 'EGGS', name: 'Boiled Eggs', category: 'other', unitPrice: 3.5, saleType: 'fixed_unit', department: 'bakery' },
  { code: 'HOTDOG_VIE', name: 'Hotdog + Vienna', category: 'other', unitPrice: 10, saleType: 'fixed_unit', department: 'bakery' },

  // Sandwiches
  { code: 'SW_HOTDOG', name: 'Hotdog Sandwich', category: 'sandwiches', unitPrice: 10, saleType: 'discrete', department: 'bakery' },
  { code: 'SW_S8', name: 'Sandwich R8', category: 'sandwiches', unitPrice: 8, saleType: 'discrete', department: 'bakery' },
  { code: 'SW_S11', name: 'Sandwich R11', category: 'sandwiches', unitPrice: 11, saleType: 'discrete', department: 'bakery' },
  { code: 'SW_S13', name: 'Sandwich R13', category: 'sandwiches', unitPrice: 13, saleType: 'discrete', department: 'bakery' },
  { code: 'SW_S15', name: 'Sandwich R15', category: 'sandwiches', unitPrice: 15, saleType: 'discrete', department: 'bakery' },
  { code: 'SW_S17', name: 'Sandwich R17', category: 'sandwiches', unitPrice: 17, saleType: 'discrete', department: 'bakery' },
  { code: 'SW_S18', name: 'Sandwich R18', category: 'sandwiches', unitPrice: 18, saleType: 'discrete', department: 'bakery' },
  { code: 'SW_S19', name: 'Sandwich R19', category: 'sandwiches', unitPrice: 19, saleType: 'discrete', department: 'bakery' },
  { code: 'SW_S21', name: 'Sandwich R21', category: 'sandwiches', unitPrice: 21, saleType: 'discrete', department: 'bakery' },
  { code: 'SW_S23', name: 'Sandwich R23', category: 'sandwiches', unitPrice: 23, saleType: 'discrete', department: 'bakery' },
  { code: 'SW_SCB', name: 'SCB Rama Sandwich', category: 'sandwiches', unitPrice: 13, saleType: 'discrete', department: 'bakery' },
  { code: 'SW_BURGER', name: 'Burger Sandwich', category: 'sandwiches', unitPrice: 15, saleType: 'discrete', department: 'bakery' },
]

// --- Legacy product code aliases ---
// Distribution docs in Firestore from before the Phase 1 masterlist update
// use shortened product codes that no longer exist in BAKERY_PRODUCTS_SEED.
// At read time, alias resolution maps these to the current canonical codes
// so the price lookup succeeds and projected totals are correct.
//
// At migration time (window.migrateBakeryProductCodes), each legacy doc is
// rewritten in place: productCode is updated, the deterministic doc id is
// recomputed, the new record is pushed to Firestore, and the old Firestore
// doc is deleted so backgroundSyncForDate cannot re-inject the legacy code.
//
// SC4 ("Scones (4)") is intentionally NOT aliased — that code is canonical
// in the current seed.
export const BAKERY_PRODUCT_CODE_ALIASES = {
  'BRD':   'BREAD',
  'HBRD':  'BREAD',
  'BUNS':  'SBUNS_20',
  'MSB2':  'MSB_2',
  'MSB3':  'MSB_3',
  'MSB4':  'MSB_4',
  'MSB6':  'MSB_6',
  'MSB12': 'MSB_12',
  'SCN':   'SCONES',
  'WROL':  'WR_6',
  'WR4':   'WR_4',
  'YROL':  'YEL_ROLLS',
  'YBUNS': 'YEL_BUNS',
  'FCK':   'FATCOOK',
  'GNGR':  'GINGER',
  'SCB':   'SCB_RAMA',
  'SBPOL': 'SCB_POL',
  'SBPA':  'SB_POL_ATC',
}

// --- Distribution Points/Sites ---

export const DISTRIBUTION_POINTS_SEED = [
  { id: 'shoponi', name: 'Distribution Shop (Shoponi)', shortName: 'Shoponi', paymentType: 'cash' },
  { id: 'makhado', name: 'Makhado Takie', shortName: 'Makhado', paymentType: 'cash' },
  { id: 'biaba', name: 'Biaba Thabelo', shortName: 'Biaba', paymentType: 'cash' },
  { id: 'spaza', name: 'Spaza Matome', shortName: 'Spaza', paymentType: 'cash' },
  { id: 'premjee', name: 'Premjee', shortName: 'Premjee', paymentType: 'invoice' },
  { id: 'police', name: 'Police Station', shortName: 'Police', paymentType: 'invoice' },
  { id: 'makhadzi', name: 'Makhadzi (Sandwiches)', shortName: 'Makhadzi', paymentType: 'cash' },
  { id: 'town', name: 'TOWN (Mable)', shortName: 'Town', paymentType: 'cash' },
  { id: 'spaza2', name: 'Distribution Thapelo', shortName: 'Thapelo', paymentType: 'cash' },
]

function loadDistributionPoints() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_DIST)
    return raw ? JSON.parse(raw) : []
  } catch { return [] }
}

function saveDistributionPoints(points) {
  localStorage.setItem(STORAGE_KEY_DIST, JSON.stringify(points))
  // Sync to Firestore
  syncDistPointsToFirestore(points)
}

async function syncDistPointsToFirestore(points) {
  try {
    const { db } = await import('../lib/firebase')
    const { doc, setDoc } = await import('firebase/firestore')
    await setDoc(doc(db, 'bakeryConfig', 'distributionPoints'), { points })
  } catch {}
}

export function getDistributionPoints() {
  const custom = loadDistributionPoints()
  if (custom.length > 0) return custom
  return DISTRIBUTION_POINTS_SEED
}

export function addDistributionPoint(point) {
  const current = getDistributionPoints()
  const id = point.name.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '')
  const record = { id, ...point, custom: true }
  current.push(record)
  saveDistributionPoints(current)
  return record
}

export function removeDistributionPoint(id) {
  const current = getDistributionPoints().filter(p => p.id !== id)
  saveDistributionPoints(current)
}

export function updateDistributionPoint(id, updates) {
  const current = getDistributionPoints()
  const idx = current.findIndex(p => p.id === id)
  if (idx >= 0) {
    current[idx] = { ...current[idx], ...updates }
    saveDistributionPoints(current)
    return current[idx]
  }
  return null
}

// Production shift types
export const SHIFTS = [
  { value: 'night', label: 'Night Shift' },
  { value: 'day', label: 'Day Shift' },
]
